export const UPLOAD_IMAGE_TYPES = 'image/png,image/jpeg,image/jpg';
export const UPLOAD_VIDEO_TYPES = 'video/*';
